var exports = {
  "C": "x4c3adb35--2c425d--loupe",
};

module.exports = exports;
